
import type { User } from '../types/user';
import type { Constraints, UnmetConstraints } from '../types';

/**
 * Check if the profile information of the current user matches a set of constraints.
 *
 * Returns the fields that do not match the given constraints, including the constraints.
 */
const checkConstraints = (user: User | null | undefined, constraints: any) => {
  if (!constraints) return { pending: false, unmetConstraints: {} };

  if (!user || !user.profile) {
    return { pending: true, unmetConstraints: {} };
  }

  const { profile } = user;
  const unmetConstraints: UnmetConstraints = Object.entries(constraints as Constraints)
    .reduce((acc, [field, rules]) => {
      // @ts-expect-error
      const [{ value } = { value: '' }] = profile[field] ?? [];
      if (!value) return acc; // skip if no value

      const fieldUnmet: Partial<UnmetConstraints[string]> = {};

      if (rules.required && !value) {
        fieldUnmet.required = true;
      }

      if (rules.disallow?.includes(value)) {
        fieldUnmet.disallow = rules.disallow;
      }

      if (Object.keys(fieldUnmet).length > 0) {
        acc[field] = fieldUnmet;
      }

      return acc;
    }, {} as UnmetConstraints);

  return { pending: false, unmetConstraints };
};

export default checkConstraints;
